import store from "redux/store";



//Old Permissions Object for reference
// const permissions = {
//   RequisitionsView: "View_Requisitions",
//   RequisitionsCreateUpdate: "Create_Update_Requisitions",
//   RequisitionsDelete: "Delete_Requisitions",
//   ApprovalsView: "View_Approvals",
//   ApprovalsApprove: "Approve_Approvals",
//   ApprovalsReturnToRequestor: "ReturnToRequestor_Approvals",
//   ApprovalsReject: "Reject_Approvals",
//   ApprovalsCancel: "Cancel_Approvals",
//   ApprovalsSuperApproval: "SuperApproval_Approvals",
// };

//all permissions for reference i.e Fleet-Admin, Super-Admin, Equipment-Orderer and Approver
const permissions = {
  AlignVendorReports : "Align_VendorReports",
  ApprovalsApprove : "Approve_Approvals",
  ApproveTransfersApprovals : "Approve_Transfers_Approvals",
  ApproveVendorReports : "Approve_VendorReports",
  ApprovalsCancel : "Cancel_Approvals",
  CancelTransfersApprovals : "Cancel_Transfers_Approvals",
  CreateCategories : "Create_Categories",
  CreateProducts : "Create_Products",
  CreateReports : "Create_Reports",
  CreateSubcategories : "Create_Subcategories",
  CreateSuppliers : "Create_Suppliers",
  RequisitionsCreateUpdate : "Create_Update_Requisitions",
  CreateUpdateTransfers : "Create_Update_Transfers",
  DeleteCategories : "Delete_Categories",
  DeleteProducts : "Delete_Products",
  DeleteRebateAgreements : "Delete_RebateAgreements",
  RequisitionsDelete : "Delete_Requisitions",
  DeleteSubcategories : "Delete_Subcategories",
  DeleteSuppliers : "Delete_Suppliers",
  DeleteTransfers : "Delete_Transfers",
  DesignReports : "Design_Reports",
  ModifyReports : "Modify_Reports",
  ModifyVendorReports : "Modify_VendorReports",
  ApprovalsReject : "Reject_Approvals",
  RejectTransfersApprovals : "Reject_Transfers_Approvals",
  ApprovalsReturnToRequestor : "ReturnToRequestor_Approvals",
  ReturnToRequestorTransfersApprovals : "ReturnToRequestor_Transfers_Approvals",
  RunReports : "Run_Reports",
  SubmitVendorReports : "Submit_VendorReports",
  ApprovalsSuperApproval : "SuperApproval_Approvals",
  SuperApprovalTransfersApprovals : "SuperApproval_Transfers_Approvals",
  UpdateCategories : "Update_Categories",
  UpdateProducts : "Update_Products",
  UpdateRebateAgreements : "Update_RebateAgreements",
  UpdateSubcategories : "Update_Subcategories",
  UpdateSuppliers : "Update_Suppliers",
  ApprovalsView : "View_Approvals",
  ViewCategories : "View_Categories",
  ViewProducts : "View_Products",
  ViewRebateAgreements : "View_RebateAgreements",
  ViewReports : "View_Reports",
  RequisitionsView : "View_Requisitions",
  ViewSubcategories : "View_Subcategories",
  ViewSuppliers : "View_Suppliers",
  ViewTransfers : "View_Transfers",
  ViewTransfersApprovals : "View_Transfers_Approvals",
  ViewVendorReports : "View_VendorReports",
  SetUpApprovalHierarchy : "Set_Up_Approval_Hierarchy",
  CreateUpdateApprovalGroup : "Create_Update_Approval_Group",
  DeleteApprovalGroup : "Delete_Approval_Group",
  DeletePurchaseOrder : "Delete_PurchaseOrders",
  CreateUpdatePurchaseOrders : "Create_Update_PurchaseOrders",
  ViewPurchaseOrders: "View_PurchaseOrders",
  ViewFleetAdminTasks: "View_FleetAdminTasks",
  UpdateFleetAdminTasks: "Update_FleetAdminTasks",
  EditFleetAdminTasks: "Edit_FleetAdminTasks",
  SuperApproval_Approvals: "SuperApproval_Approvals",
  CreateUpdateBulkOrder: "Create_Update_BulkOrder",
  DeleteBulkOrder: "Delete_BulkOrder",
  ViewBulkOrder: "View_BulkOrder",
  ViewApprovalsBulkOrder: "View_Approvals_BulkOrder",
  ApproveApprovalsBulkOrder:"Approve_Approvals_BulkOrder",
  ReturnToRequestorApprovalsBulkOrder: "ReturnToRequestor_Approvals_BulkOrder",
  RejectApprovalsBulkOrder: "Reject_Approvals_BulkOrder",
  CancelApprovalsBulkOrder: "Cancel_Approvals_BulkOrder",
  ViewCatalog: "View_Catalog",
  View_JobTitle: "View_JobTitle",
  CreateUpdateReports: "Create_Update_Reports",
  DeleteReport : "Delete_Reports",
  CreateEditMAScan: "Create_Edit_MA_Scanning",
  UploadMAScan : "Upload_MA_Scanning",
  ViewMAReport : "View_MA_Report",
  ViewMAScanning : "View_MA_Scanning",
  ViewAdmin : "View_Admin",
  SetPreAuthorized: "Approval_Override_Pre-Authorized",
  CreateEditCatalog: "Create_Edit_Catalog",
  Create_Edit_JobTitle: "Create_Edit_JobTitle",
  Reset_Training: "Reset_Training",
  Assign_Users: "Assign_Users",
  View_Users: "View_Users",
  ViewAssetInventoryModule: "View_Asset_Inventory_Module",
  CreateAssessment: 'Create_Assessment',
  CreateEditAudit:'Create_Edit_Audit',
  ExportCurrentYearUserReports: "Export_CurrentYear_UserReports",
  ExportPreviousYearUserReports: "Export_PreviousYear_UserReports",
  View_AssetAuditReadinessWB: "View_AssetAuditReadinessWB",
  SaveEdit_AssetAuditReadinessWB: "SaveEdit_AssetAuditReadinessWB",
  Send_PO_Vendor_Email: "Send_PO_Vendor_Email",
  Refresh_PurchaseOrder: "Refresh_PurchaseOrder",
  View_VendorEmail_HistoryTab: "View_VendorEmail_HistoryTab",
  View_PO_HistoryTab: "View_PO_HistoryTab",
  Remove_Branch_Admin_CostCenter: "Remove_Branch_Admin_CostCenter",
  View_Branch_Admin_CostCenter: "View_Branch_Admin_CostCenter",
  Create_Branch_Admin_Assignment: "Create_Branch_Admin_Assignment",
  ViewHierarchy: 'View_Hierarchy',
  CreateEditHierarchy: 'Create_Edit_Hierarchy',
  DeleteHierarchy: 'Delete_Hierarchy',
  Create_Edit_Admin : "Create_Edit_Admin",
  ViewOOFSettings : "View_OOF_Settings",
  ViewApprovalHistory : "View_Approval_History",
  ViewComplianceReport: "View_Compliance_Report",
  ViewAssessment: 'View_Assessment',
  ViewAudit:'View_Audit',
  ViewUserReports: 'View_UserReports',
  CreateUpdateAfeRequest: 'Create_Update_AFE_Request',
  ViewAllPendingApprovals: 'View_All_PendingApprovals'
}

export const ACCESS_DENIED = "You're not allowed to access this feature";

export const isAuthorized = (permission: string) => {
  const state = store.getState();
  const permissions = state?.UserProfile?.getUserDetails?.permissions || [];

  return permissions.includes(permission);
};

export const isUserAuthorized = () => {
  const state = store.getState();
  const emailId = state?.UserProfile?.getUserDetails?.emailId;
  const isEmailIdPresent = emailId !== null && emailId !== undefined && emailId !== "";
  return isEmailIdPresent; 
};

export default permissions;
